export const CMS_DEMO_BLOB_PREFIX = 'NIN/CMS/demo'

export const CMS_DEMO_BLOB_HOST =
  process.env.NEXT_PUBLIC_VERCEL_BLOB_HOST ??
  'https://2mjii5xz7qwzm2qx.public.blob.vercel-storage.com'

export const CMS_DEMO_FILES = {
  gmail: 'seed/gmail/gmail_demo.mp4',
  calendar: 'seed/calendar/calendar_demo.mp4',
  twitterX: 'seed/twitter-x/twitter_demo.mp4',
  health: 'seed/health/health_demo.mp4',
  healthPoster: 'seed/health/health_poster.png',
  groww: 'seed/groww/groww_demo.mp4',
  systemControl: 'seed/system-control/system_control_demo.mp4',
} as const

export type CmsDemoAssetKey = keyof typeof CMS_DEMO_FILES

export function getCmsDemoAssetUrl(key: CmsDemoAssetKey): string {
  return `${CMS_DEMO_BLOB_HOST}/${CMS_DEMO_BLOB_PREFIX}/${CMS_DEMO_FILES[key]}`
}

export const CMS_DEMO_ASSET_URLS = {
  gmail: getCmsDemoAssetUrl('gmail'),
  calendar: getCmsDemoAssetUrl('calendar'),
  twitterX: getCmsDemoAssetUrl('twitterX'),
  health: getCmsDemoAssetUrl('health'),
  healthPoster: getCmsDemoAssetUrl('healthPoster'),
  groww: getCmsDemoAssetUrl('groww'),
  systemControl: getCmsDemoAssetUrl('systemControl'),
} as const
